<template>
<div>
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->

    <BarraNavegar v-if="!this.$store.state.uidUser"></BarraNavegar>
    <BarraNavegacionActivo v-else></BarraNavegacionActivo>
    <IndicadoresEconomicosDiario></IndicadoresEconomicosDiario>

    <router-view />
    <Footer></Footer>
</div>
</template>

<script>
import {
    indicadoreseconomicos
} from './configuracion/conexionAPI';
import IndicadoresEconomicosDiario from './components/IndicadoresEconomicosDiario';
import BarraNavegacionActivo from './components/BarraNavegacionActivo';
import BarraNavegar from './components/BarraNavegar';

import axios from 'axios';
import Footer from './components/Footer';
import firebase from 'firebase';

export default {
    name: 'App',

    components: {
        IndicadoresEconomicosDiario,
        BarraNavegar,
        BarraNavegacionActivo,
        Footer
    },

    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.$store.dispatch('accesoUsuario', user.uid)
            } else {
                console.log('Salida de usuario')
                this.$store.dispatch('accesoUsuario', '')
            }
        });
        indicadoreseconomicos();
        this.$store.dispatch('llamarclientes');
        this.$store.dispatch('llamarfactorplanta');
        this.$store.dispatch('llamardistribuidora');
        this.$store.dispatch('llamartarifa');
        this.$store.dispatch('llamarpaneles'); //desde aca traer data desde cloud firestore
        this.$store.dispatch('llamarinversores'); //desde aca traer data desde cloud firestore
        this.$store.dispatch('llamaractividades'); // traer data desde cloud firestore
        this.$store.dispatch('llamarseguimientoactividades'); // treaer data de las actividades realizas en la instalación de la P F.V.

        //this.addDataPaneles();      //para llamar data local archivo JSON
        //this.addDataInversores();   //para llamar data local archivo JSON

    },
    methods: {
        addDataPaneles() {
            return axios.get('json/paneles.json', {
                    baseURL: window.location.Origin
                })
                .then((response) => {
                    this.$store.dispatch('llamarpaneles', response.data[0]);
                    return response.data;
                })
                .catch((error) => {
                    throw error.response.data;
                });
        },
        addDataInversores() {
            return axios.get('json/inversores.json', {
                    baseURL: window.location.Origin
                })
                .then((response) => {
                    this.$store.dispatch('llamarinversores', response.data[0]);
                    return response.data;
                })
                .catch((error) => {
                    throw error.response.data;
                });
        }
    }
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

// fuentes y familia 
.Oleo {
    font-family: 'Oleo Script', cursive;
    font-size: 24px;
}

.Solway {
    font-family: 'Solway', serif;
}

@import url('https://fonts.googleapis.com/css2?family=Oleo+Script&family=Solway:wght@500&display=swap');

//cambio de color de valor por defecto de bootstrap primary
$primary: #123456;
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
